(() => {
  "use strict";

  const marker = "jazzis_cart_session_cleared";
  const bypassParameter = "__jazzis_cart_session_reset";
  const documentRoot = document.documentElement;
  const hasCookie = () => document.cookie.split(";").some(cookie =>
    cookie.trim() === `${marker}=1`
  );

  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get(bypassParameter) === "1") {
      url.searchParams.delete(bypassParameter);
      window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
      return;
    }
  } catch { /* Continue with the ordinary session check. */ }

  try {
    if (hasCookie()) return;
  } catch { /* Try sessionStorage if cookies cannot be read. */ }

  try {
    if (window.sessionStorage.getItem(marker) === "1") return;
  } catch { /* The URL marker below handles storage-disabled browsers. */ }

  const previousVisibility = documentRoot.style.visibility;
  documentRoot.style.visibility = "hidden";
  const root = window.Shopify?.routes?.root || "/";

  fetch(`${root}cart/clear.js`, {
    method: "POST",
    headers: { Accept: "application/json" }
  }).then(response => {
    if (!response.ok) throw new Error("The Shopify cart could not be cleared.");

    let markerStored = false;
    try {
      const secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = `${marker}=1; Path=/; SameSite=Lax${secure}`;
      markerStored = hasCookie();
    } catch { /* Try tab-scoped storage. */ }

    try {
      window.sessionStorage.setItem(marker, "1");
      markerStored = markerStored || window.sessionStorage.getItem(marker) === "1";
    } catch { /* The one-time URL marker is the final fallback. */ }

    if (markerStored) {
      window.location.reload();
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set(bypassParameter, "1");
    window.location.replace(url.href);
  }).catch(() => {
    documentRoot.style.visibility = previousVisibility;
  });
})();
